import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../utils/AuthProvider";
import { ContactDataHubProvider } from "../utils/SignalR";
import { PhoneVerificationProvider } from "../utils/PhoneVerificationProvider";
import PhoneVerificationBanner from "./PhoneVerificationBanner";

export function ProtectedRoutes() {
    const { cookies } = useAuth();
    const location = useLocation();

    if (!cookies.jwtToken) {
        return <Navigate to="/signin" state={{ from: location }} replace />;
    }

    return (
        <ContactDataHubProvider>
            <PhoneVerificationProvider>
                <PhoneVerificationBanner />
                <Outlet />
            </PhoneVerificationProvider>
        </ContactDataHubProvider>
    );
}
